import StepModalConfirmationPanel from './component'
export default StepModalConfirmationPanel
